import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Collapse, NavLink } from 'reactstrap';
import { ACTIONS, NAMESPACER } from '../../../constants/const';
import { createNamespacer } from '../../../utils/reducers';
import IconHelper from '../infoLabel/iconHelper';

const upIcon = 'fas fa-sort-up ml-auto sort-umt';
const downIcon = 'fas fa-sort-down ml-auto sort-umb';

const SideBarSubMenu = ({ name, nestedNavItems, namespacerAction, icon }) => {
  const namespacer = createNamespacer(NAMESPACER.SUPPORT);
  const dispatch = useDispatch();
  const toggleSubMenu = useSelector((state) => {
    let openState = null;
    if (namespacerAction === ACTIONS.STATEMENT_NAV_OPEN) {
      openState = state.support.statementNavOpen;
    } else if (namespacerAction === ACTIONS.GL_CONFIGURATION_NAV_OPEN) {
      openState = state.support.glConfigNavOpen;
    } else if (namespacerAction === ACTIONS.JOURNALS_NAV_OPEN) {
      openState = state.support.journalsNavOpen;
    } else if (namespacerAction === ACTIONS.DASHBOARD_NAV_OPEN) {
      openState = state.support.dashboardNavOpen;
    }
    return openState;
  });
  const setToggle = (isOpen) => {
    dispatch({
      type: namespacer(namespacerAction),
      payload: { isOpen },
    });
  };
  return (
    <>
      <div
        className="nav-link"
        onClick={() => {
          setToggle(!toggleSubMenu);
        }}
      >
        <div
          style={{
            display: 'flex',
          }}
          className="gl-down-icon"
        >
          {icon && <IconHelper iconType={icon} />}
          {name}

          <span style={{ marginLeft: '8px', marginTop: '2px' }}>
            <i className={toggleSubMenu ? upIcon : downIcon} />
          </span>
        </div>
      </div>

      <Collapse isOpen={toggleSubMenu}>
        <div className="sub-navlinks">
          {nestedNavItems?.map((item) => {
            return (
              <NavLink
                key={`submenu-${item.link}`}
                activeClassName="nav-active"
                className="text-left"
                tag={RouterNavLink}
                to={`${item.link}`}
              >
                {item.name}
              </NavLink>
            );
          })}
        </div>
      </Collapse>
    </>
  );
};

SideBarSubMenu.propTypes = {
  name: PropTypes.string.isRequired,
  nestedNavItems: PropTypes.arrayOf(PropTypes.object),
  namespacerAction: PropTypes.string.isRequired,
};

SideBarSubMenu.defaultProps = {
  nestedNavItems: null,
};

export default SideBarSubMenu;
